import React from 'react';
import { Text } from 'components/core';
import { Stack } from 'components/layout';

export type StudyListProps = {
  hasReachedMaxAIResults: boolean;
};

const ReachedMaxAIResults = ({ hasReachedMaxAIResults }: StudyListProps) => {
  if (!hasReachedMaxAIResults) {
    return null;
  }

  return (
    <Stack spacing={1} alignX="center">
      <Text variant="medium">
        You&apos;ve reached the limit of studies that can be shown when sorting
        by “Most relevant”.
      </Text>
      <Text variant="medium">To see more, try a different sorting option.</Text>
    </Stack>
  );
};

export default ReachedMaxAIResults;
